var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isVisible)?_c('div',{staticClass:"bottom-menu",style:({width: _vm.width})},[_c('v-divider'),_c('v-container',{staticClass:"px-4",attrs:{"fluid":""}},[_vm._t("default")],2)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }